import { Subject, Observable } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnCamera } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';
import { ClipViewVideoDialogComponent } from '@lib/sentry';
import { SnActionConfig } from '@lib/ui/actions';
import { SnDataListComponent } from '@lib/ui/data-list';

import { DetectionImageDialogComponent } from '../detection-image-dialog/detection-image-dialog.component';

@Component({
  selector: 'sn-camera-events-list',
  templateUrl: './camera-events-list.component.html',
  styleUrls: ['./camera-events-list.component.scss'],
})
export class CameraEventsListComponent implements OnInit {
  @ViewChild('list', { static: false })
  public readonly list: SnDataListComponent<SnCamera>;

  @Input() public camera: SnCamera;
  public readonly loadData = this._loadData.bind(this);
  public readonly actions: SnActionConfig[] = this._getActions();
  public readonly placeHolderImageUrl = 'assets/map-icons/No_Image_Found.png';

  public columns = ['thumbnail', 'label', 'type', 'timestamp', 'actions'];

  private readonly _destroy$ = new Subject<void>();

  constructor(private readonly _camerasAPI: SnCamerasAPI, private readonly _dialog: MatDialog) {}

  public ngOnInit(): void {}

  public trackBy(index: number, item: any): any {
    return index;
  }

  public onImageSelected(url: string): void {
    this._dialog.open(DetectionImageDialogComponent, {
      data: url,
    });
  }

  public isValidImageUrl(url: string): boolean {
    if (!url || !url.trim()) {
      return false;
    }
    // Check for common invalid patterns
    const trimmedUrl = url.trim();
    return !trimmedUrl.includes('null') && 
           !trimmedUrl.includes('undefined') && 
           trimmedUrl !== '' && 
           trimmedUrl !== 'null' && 
           trimmedUrl !== 'undefined';
  }

  private _loadData(params?: ISnListQueryParameters): Observable<ISnListResponse<any>> {
    return this._camerasAPI.getAiCamera(this._prepareQueryParams(params)).pipe(
      map((response) => {
        return {
          count: response.count,
          total: response.totalPages,
          results: response.results,
        };
      }),
      tap((response) => {}),
      takeUntil(this._destroy$),
    );
  }

  private _prepareQueryParams(params: any): any {
    return {
      ordering: {
        active: 'name',
        direction: 'asc',
      },
      camera_id__in: this.camera.id,
      ...params,
    };
  }

  private _getActions(): SnActionConfig[] {
    return [
      {
        label: 'Options',
        icon: {
          fontSet: 'fal',
          fontIcon: 'fa-ellipsis-vertical',
        },
        menu: {
          items: [
            {
              label: 'View clip',
              icon: {
                fontIcon: 'fa-film',
                fontSet: 'fal',
              },
              click: (item) => {
                this._camerasAPI
                  .getCamera(item.cameraId)
                  .pipe(takeUntil(this._destroy$))
                  .subscribe({
                    next: (camera) => {
                      this._dialog.open(ClipViewVideoDialogComponent, {
                        data: {
                          camera,
                          item,
                          snapshot: item.playbackUrls,
                          resulution: item.resolution,
                        },
                      });
                    },
                  });
              },
            },
          ],
        },
      },
    ];
  }
}
